import { Button, Modal } from 'antd';
import React from 'react';
import { WarningTwoTone } from '@ant-design/icons';

interface ErrorModalProps {
  visible: boolean;
  message: string | undefined;
  title?: string;
  onClose: () => void;
  onOk?: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  title,
  visible,
  message,
  onClose,
  onOk,
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      centered
      maskClosable={false}
      closeIcon={null}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Close
        </Button>,
        onOk !== undefined ? (
          <Button type="primary" key="ok" onClick={onOk}>
            OK
          </Button>
        ) : null,
      ]}
    >
      <div className="flex flex-col items-center text-center">
        <div>
          <WarningTwoTone twoToneColor="#ffcc00" style={{ fontSize: '80px' }} />
        </div>
        <div className="font-semibold text-xl my-2">{title}</div>
        <div>{message}</div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
